var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts-bar-wrap-box"},[_c('div',{ref:"echart",staticClass:"echarts-bar-wrap"})])
}
var staticRenderFns = []

export { render, staticRenderFns }